var NATIVE_SYMBOL = require('../internals/symbol-constructor-detection');

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;



// WEBPACK FOOTER //
// /Users/stephen.tait/Local Sites/storyiq/app/public/web/wp-content/themes/jaywing/node_modules/core-js/internals/symbol-registry-detection.js